import styled from 'styled-components';
import {tableColSetup, tableHoverSetup} from './tableSetup/tableSetup.js';

import {inContainerFormControlColors} from '../../../shared-components/variables/componentColors/formControlVariableColors.js';
import {colorTheme} from '../../mixin/colorTheme.js';
import {TableData} from './table-sections/TableData.js';
import {TableHeader} from './table-sections/TableHeader.js';
import {TableRow} from './table-sections/TableRow.js';
import {TableModifier} from './TableModifier.js';
import {tableSizeSetup} from './tableSetup/tableSizeSetup.js';

export const TableWrapper = styled(TableModifier)`
    --marked: var(--container-background-active-color-100);
    ${colorTheme({
        '--odd-input-background-color': {dark: 'var(--black-04)', light: 'var(--slate-00)'},
        '--odd-input-border-color': {dark: 'var(--black-13)', light: 'var(--gray-02)'},
        '--even-input-background-color': {dark: 'var(--black-04)', light: 'var(--white-00)'},
        '--even-input-border-color': {dark: 'var(--black-12)', light: 'var(--gray-02)'},
    })};

    ${({hover}) => tableHoverSetup(hover)};
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 5px;
    padding: 0 2px;
    position: relative;
    margin-bottom: var(--space-md);

    thead ${TableRow} {
        background: var(--table-header-row-background);
        color: var(--table-header-row-text-color);
        box-shadow: var(--table-data-row-shadow);
        ${inContainerFormControlColors};
        @-moz-document url-prefix() {
            background: none;
            ${TableHeader} {
                background: var(--table-header-row-background);
            }
        }
    }
    tbody ${TableRow} {
        box-shadow: var(--table-shadow);
        color: var(--table-data-row-text-color);

        &:nth-of-type(odd) {
            background-color: var(--table-data-row-background-odd); //Default setup
            --form-control-background-color: var(--odd-input-background-color);
            --form-control-border-color: var(--odd-input-border-color);
            --form-word-fix-border-color: var(--odd-input-border-color);
            @-moz-document url-prefix() {
                background: none;
                ${TableData} {
                    background-color: var(--table-data-row-background-odd); //Default setup
                }
            }
        }
        &:nth-of-type(even) {
            background-color: var(--table-data-row-background-even); //Default setup
            --form-control-background-color: var(--even-input-background-color);
            --form-control-border-color: var(--even-input-border-color);
            --form-word-fix-border-color: var(--even-input-border-color);
            @-moz-document url-prefix() {
                background: none;
                ${TableData} {
                    background-color: var(--table-data-row-background-even); //Default setup
                }
            }
        }
    }

    /**
     * Note: normally you should use Table.Data, but in very large tables this has a negative performance impact. In that
     * case, directly use a td instead
     */
    td {
        ${tableColSetup({})}
        min-width: 40px;
        width: min-content;
        vertical-align: middle;
        white-space: nowrap;
    }

    ${({size}) => tableSizeSetup(size)};
`;
